import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import ChartPrognoza from './ChartPrognoza';
import FinanciarFunctions from './FinanciarFunctions';
import InterpretareComponent1 from './InterpretareComponent1';
import InterpretareLabelComponent from './InterpretareLabelComponent';
import PlanificareDialog from './PlanificareDialog';


export default class PlanificarePrognoza extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            prognozat: {},
            prognoze: [],
            arrow1: false,
            arrow2: false,
            arrow3: false,
            openPrognoza:false
        }
    }

    f = new FinanciarFunctions()
    ws = new Ws()
    u = new Utils()

    componentDidMount() {
        this.getPrognoza()
    }


    displayArrow = (arr) => {

        this.setState({ [arr]: true })
    }



    getPrognoza = async () => {

        let getPrognoza = await this.ws.customSelect('select * from fin_planificari where an = @p1 and tip = @p2 order by an asc', {
            p1: this.props.bilanturiDesc[0].an + 1,
            p2:'venit'
        })


        console.warn('getPrognoza :>> ', getPrognoza);
        if (getPrognoza.Succes) {
            if (getPrognoza.Content.length > 0) {
                let prognoza = { ...getPrognoza.Content[getPrognoza.Content.length - 1] }


                this.setState({
                    prognozat: prognoza,
                    prognoze: getPrognoza.Content
                })
            } else {


                let prognoza = {
                    an: this.props.bilanturiDesc[0].an + 1,
                    valoare: 0,
                    tip:'venit'

                }

                let insertPrognoza = await this.ws.insert('fin_planificari', prognoza)

                console.log('insertPrognoza :>> ', insertPrognoza);


                if (insertPrognoza.Succes) {
                    this.getPrognoza()
                }
            }

        }
    }

    changePrognoza = (ev) =>{

        let prognoza = {...this.state.prognozat}

        let v = ev.target.value
        let n = ev.target.name

        prognoza[n] = v

        this.setState({prognozat:prognoza})
    }

    salveazaPrognoza = async() =>{


        let salveazaPrognoza = await this.ws.update('fin_planificari', {valoare:this.state.prognozat.valoare}, {id:this.state.prognozat.id})


        if(salveazaPrognoza.Succes){

            this.setState({openPrognoza:false},()=>{

                this.getPrognoza()

            })
        }



    }


    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



            <PlanificareDialog
                open={this.state.openPrognoza}
                onClose={()=>{this.setState({openPrognoza:false})}}
                prognozat={this.state.prognozat}
                changePrognoza={this.changePrognoza}
                salveazaPrognoza={this.salveazaPrognoza}
                />


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.venituriSiPreviziuni} </h5>


                    <Divider className='pm-divider' />
                </Grid>


                <Grid style={{ textAlign: 'left', lineHeight: 1, marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12, color: 'rgb(121	121	121	)' }}>{this.dictionary.financiar.mesajPrognoza}</span>
                </Grid>

                <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid flexgrow={1} spacing={3} container>
                        <Grid item xs>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{this.dictionary.financiar.an}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.venituri}</span>
                                </Grid>
                            </Grid>
                        </Grid>


                        {this.props.bilanturiAsc.map((b, idx) => {

                            return (
                                <Grid key={idx} item xs>
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{b.an}</span>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber(this.f.getTotalVenituriBilant(b)) } Lei</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )

                        })}


                        <Grid item xs>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{this.dictionary.financiar.planificare} {this.props.bilanturiDesc[0].an + 1}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber(this.state.prognozat.valoare) } Lei</span>
                                </Grid>
                                <Grid onClick={()=>{this.setState({openPrognoza:true})}}  item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span style={{ textAlign: 'left', paddingLefft: 20, textDecoration: 'underline', color: '#94c3f3', fontSize: 14, cursor: 'pointer' }} >{this.dictionary.financiar.editeazaPlanificarea} </span>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{this.dictionary.financiar.previzionat} {this.props.bilanturiDesc[0].an + 1}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber(this.f.calculPrognoza(this.props.bilanturiAsc)) } Lei</span>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {/* todo grafic prognoza */}
                    {this.props.bilanturiAsc.length > 0 && this.state.prognoze.length > 0 &&
                        <ChartPrognoza
                            bilanturi={this.props.bilanturiAsc}
                            prognozat={this.state.prognozat}
                        />
                    }


                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>

                <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>

                        <Grid item xs>
                            {this.props.bilanturiDesc &&
                                <InterpretareComponent1
                                labels={[this.dictionary.financiar.slab , this.dictionary.financiar.mediu, this.dictionary.financiar.foarteBine]}
                                    arrow1={this.state.arrow1}
                                    arrow2={this.state.arrow2}
                                    arrow3={this.state.arrow3}
                                    displayArrow={this.displayArrow}
                                    val1={this.f.diferentaTotalVenituri(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1])}
                                    val2={null}
                                    cF1={0}
                                    cF2={7}
                                />
                            }

                        </Grid>

                        <Grid item xs>

                            {this.props.bilanturiDesc &&
                                <InterpretareLabelComponent
                                slab={this.dictionary.financiar.slab}
                                mediu={this.dictionary.financiar.mediu}
                                foarteBine={this.dictionary.financiar.foarteBine}
                                dictionary={this.dictionary}

                                    val1={this.f.diferentaTotalVenituri(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1])}
                                    val2={null}
                                    cF1={0}
                                    cF2={7}
                                />
                            }


                        </Grid>
                    </Grid>

                </Grid>

                <Grid style={{textAlign: 'left'}}  item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <span style={{fontSize: 12}}> {this.dictionary.financiar.prongozaText}</span>
                </Grid>
            </Grid>
        );
    }
}